import { axiosInstance } from "../../../config/axios";

export interface ConversationSummary {
  call_id: string;
  start_time: string;
  end_time: string;
  duration_seconds: number;
  user_participant: string;
  assistant_participant: string;
}

export interface ConversationMessage {
  timestamp: string;
  created_at: string;
  speaker: 'user' | 'assistant';
  sequence_order: number;
  text: string;
  type: string;
  id:number;
}

export interface ConversationDetails {
  id: number;
  call_id: string;
  start_time: string;
  end_time: string;
  duration_seconds: number;
  user_participant: string;
  assistant_participant: string;
  created_at: string;
  participants: {
    user: string;
    assistant: string;
  };
  conversation: ConversationMessage[];
  messages: ConversationMessage[];
  user_name: string;
  user_phone: string;
  user_id: number;
  summary: string;
  summary_generated_at: string;
}
export interface ConversationsResponse {
  conversations: ConversationSummary[];
}

// const API_BASE_URL = 'https://twillo-estrabilio-staging.optimusai.ai/';

export const getConversations = async (limit: number = 50, offset: number = 0) => {
  try {
    const response = await axiosInstance.get<ConversationsResponse>(
       `${import.meta.env.PROD ? '' : 'api/v1'}/conversations?limit=${limit}&offset=${offset}`);

    const data = response.data;
    return data;
  } catch (error) {
    console.warn('API connection failed, using mock data:', error);
  }
}

export const getConversationDetails = async (callId: number): Promise<ConversationDetails> => {
  try {
    const response = await axiosInstance.get(
      `${import.meta.env.PROD ? '' : 'api/v1'}/conversations/${callId}`);

    const data = await response.data;
    return data;
  } catch (error) {
    console.warn('API connection failed, using mock data for conversation:', error);
    throw error;
  }
}

export const formatDuration = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

export const formatDateTime = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export const downloadConversation = async (callId: string, format: 'txt' | 'json' = 'txt'): Promise<void> => {
  try {
    const response = await fetch(
      `/api/conversations/${callId}/download?format=${format}`,
      {
        method: 'GET',
        headers: {
          'accept': 'application/json',
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `conversation-${callId}.${format}`;
    a.click();
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading conversation:', error);
    // Fallback to manual download if API fails
    throw error;
  }
}
